module.exports = __webpack_public_path__ + "img/download-on-the-app-store-da.f6642fe9.svg";